tindie.navigation.list = (function(t, $) {
	var navigation = tindie.navigation.view,
		products = tindie.productUtils;
	var sendImpressions = function() {
		if (window.ga && ga.create) {
			ga("send", "event", "Product Browse Page", "Send Product Impressions", {
				nonInteraction: true,
				transport: "beacon"
			});
		}
	};
	var BrowsePage = function() {
		var self = this;
		navigation.call(self);
		self.productsList = ko.observableArray();
		self.createProductCard = function() {
			return products.createProductCard("Browse Products", self.productsList);
		};
	};
	t.init = function() {
		var vm = new BrowsePage();
		ko.applyBindings(vm, document.body);
		window.addEventListener("beforeunload", sendImpressions, false);
		$(".show_more").on("click", function(ev) {
			$(".all_countries").removeClass("hide");
			$(this).addClass("hide");
		});
	};
	return t;
})(tindie.navigation.list || {}, jQuery);